<template>
  <Fragment>
    <template v-if="$route.name !== 'salesPersonIndex'">
      <router-view></router-view>
    </template>
    <section class="container" v-else>
      <Breadcrumb />
      <div class="card-wrap mt-20 mb-20">
        <section class="card-content">
          <div class="left">
            <div class="search-name mr-15">
              <span>区域：</span>
              <el-select
                v-model="productTypeId"
                clearable
                placeholder="请选择区域"
              >
                <el-option
                  v-for="item in productTypeOptions"
                  :key="item.productTypeId"
                  :label="item.typeName"
                  :value="item.productTypeId"
                >
                </el-option>
              </el-select>
            </div>
            <div class="search-name mr-15">
              <span>姓名：</span>
              <el-input v-model="realName"> </el-input>
            </div>
            <el-button
              type="primary"
              class="ml-20"
              @click="searchSalesPersonInfo"
              >查询</el-button
            >
          </div>
          <el-button type="primary" class="mr-20" @click="addSalesPerson"
            >添加销售人员</el-button
          >
        </section>
      </div>
      <el-table :data="list" style="width: 150%" border>
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            <span>{{ scope.$index + (pageNum - 1) * pageSize + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="区域名称" width="250">
          <template slot-scope="scope">
            <span>{{ scope.row.typeName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="姓名" width="250">
          <template slot-scope="scope">
            <span>{{ scope.row.realName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="工号" width="250">
          <template slot-scope="scope">
            <span>{{ scope.row.staffCode }}</span>
          </template>
        </el-table-column>
        <el-table-column label="联系电话" width="250">
          <template slot-scope="scope">
            <span>{{ scope.row.linkPhone }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.status === 1 ? "启用" : "禁用" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" @click="editSalesPersonInfo(scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20 pagination"
        background
        layout="total,prev, pager, next, jumper"
        :total="total"
        :page-size="10"
        :current-page="pageNum"
        @prev-click="handlePrePage"
        @next-click="handleNextPage"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </section>
  </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";

import Breadcrumb from "@/components/Breadcrumb";
export default {
  name: "role",
  components: {
    Breadcrumb,
    Fragment
  },
  data() {
    return {
      productTypeId: "",
      realName: "",
      productTypeOptions: [],
      pmCount: "",
      list: [],
      pageNum: 1,
      pageSize: 10,
      total: 0
    };
  },
  methods: {
    getSalesPersonList() {
      let _this = this;
      let param = {
        url: "/api/salePerson/getAfterSalePersonPage",
        params: {
          productTypeId: _this.productTypeId,
          realName: _this.realName,
          pageNum: _this.pageNum,
          pageSize: _this.pageSize
        }
      };

      _this.$store.dispatch("getSalesPersonList", param).then(() => {
        _this.list = _this.$store.state.salePerson.salePersonList.list;
        _this.total = _this.$store.state.salePerson.salePersonList.total;
      });
    },
    //查询
    searchSalesPersonInfo() {
      let _this = this;
      _this.getSalesPersonList();
    },
    //当前页
    handleCurrentChange(value) {
      let _this = this;
      _this.pageNum = value;
      _this.getSalesPersonList();
    },
    //上一页
    handlePrePage() {
      let _this = this;
      _this.pageNum -= 1;
      _this.getSalesPersonList();
    },
    //下一页
    handleNextPage() {
      let _this = this;
      _this.pageNum += 1;
      _this.getSalesPersonList();
    },
    //编辑
    editSalesPersonInfo(row) {
      this.$router.push({
        name: "editSalesPersonInfo",
        params: { afterSalePersonId: row.afterSalePersonId }
      });
    },
    //添加
    addSalesPerson() {
      this.$router.push({
        name: "addSalesPersonInfo"
      });
    },
    getProductTypeList() {
      let _this = this;
      let param = {
        url: "/api/productType/getProductTypeList"
      };

      _this.$store.dispatch("getProductTypeList", param).then(() => {
        _this.productTypeOptions =
          _this.$store.state.productType.productTypeList;
      });
    }
  },
  created() {
    let _this = this;
    _this.getSalesPersonList();
    _this.getProductTypeList();
  }
};
</script>

<style lang="sass" scoped>
.card-wrap
  .card-content
    display: flex
    align-items: center
    justify-content: space-between
    .left
      display: flex
    .el-button
      font-size: 14px
    .search-name, .search-code
      font-size: 14px
      display: flex
      align-items: center
      span
        white-space: nowrap
.pagination
  text-align: center
</style>
